exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1UUMy{background:#222 url(/images/footer_bg.jpg);color:#878787;font-weight:300}._3dfAC{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-flow:wrap;flex-flow:wrap;margin:0 auto;padding:20px 15px;max-width:1000px;text-align:center}._3hPVG{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;margin:10px 0}._1T6T4{width:35%}._3DRge{width:30%}@media (max-width:441px){._1T6T4,._3DRge{width:100%}._3DRge{margin:50px 10px}}._26cEa{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-flow:wrap;flex-flow:wrap}._1VGyp{display:none;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._3qHjF{text-decoration:none}._11Mp8{color:#ddd;text-align:left;font-family:Roboto;padding-left:8px}._3Zv4h{font-size:26px;font-size:1.625rem;letter-spacing:4.48px;letter-spacing:.28rem}._1ytGa,._3Zv4h{font-weight:700;line-height:32px;line-height:2rem}._1ytGa{font-size:24px;font-size:1.5rem;text-transform:uppercase}._1lU7S{display:none;color:#ddd;font-size:22.4px;font-size:1.4rem;margin:10px auto}._2Es5w{height:100px}._6kG-A{display:none;color:#ddd;font-size:17.6px;font-size:1.1rem}.BOQeQ{border-bottom:1px solid hsla(0,0%,100%,.1);color:#ddd;font-size:22.4px;font-size:1.4rem;margin:10px auto;padding-bottom:5px;text-align:left}._3hPVG li{color:#888;font-size:15.2px;font-size:.95rem;margin:10px auto 15px;text-align:left}", ""]);

// exports
exports.locals = {
	"root": "_1UUMy",
	"container": "_3dfAC",
	"column": "_3hPVG",
	"columnSpan35": "_1T6T4",
	"columnSpan30": "_3DRge",
	"flex": "_26cEa",
	"flexCenter": "_1VGyp",
	"link": "_3qHjF",
	"title": "_11Mp8",
	"titleCn": "_3Zv4h",
	"titleEn": "_1ytGa",
	"titleIso": "_1lU7S",
	"imageIso": "_2Es5w",
	"titleIsoSmall": "_6kG-A",
	"titleHeadquarter": "BOQeQ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Footer/Footer.css
// module id = 651
// module chunks = 0 1 2 3 4 5